import TextPollItem from "./TextPollItem";

const PostTextPoll = () => {
    return (
        <div className="post-text-poll-wrapper flex flex-col justify-center items-center gap-3 py-4">
            <TextPollItem option="option 1" percent={30} />
            <TextPollItem option="option 2" percent={50} />
            <TextPollItem option="option 3" percent={20} />
        </div>
    );
};

export default PostTextPoll;
